@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.config

class TargetConfigDto(
    val newTargetMessage: String?,
    val prizeMessage: String?,
)